import Footer from "../footer/Footer";
import Header from "../header/Header";

const ErrorPage = () => {
    return (
        <div>
            <Header />
            <div className="headerOffset"></div>
            <div> hehe i couldnt find shit on this page</div>
            <div>welp such is life</div>
            <Footer />
        </div>
    );
};

export default ErrorPage;
